export type TemplateTabKey = 'fields' | 'forms' | 'sharing';

export interface ITemplateTabState {
  isDefault: boolean;
  isCustomFormFeatureEnabled: boolean;
  isScopingEnabled: boolean;
}

/**
 * The tabs shown on a template, in order.
 *
 * The default template - "Default Template: Requester Create Ticket", the single row
 * carrying IsDefault - is the one every requester creates tickets through, so it has to
 * stay visible to everyone. It gets no Sharing tab, for the same reason it gets no Fields
 * tab: those are not its to change. #35337
 */
export const buildTemplateTabKeys = ({
  isDefault,
  isCustomFormFeatureEnabled,
  isScopingEnabled
}: ITemplateTabState): TemplateTabKey[] => {
  const keys: TemplateTabKey[] = [];

  if (!isDefault) keys.push('fields');
  if (isCustomFormFeatureEnabled || isDefault) keys.push('forms');
  if (isScopingEnabled && !isDefault) keys.push('sharing');

  return keys;
};
